import { useTranslation } from 'next-i18next'
import { a, useSpring } from '@react-spring/web/dist/react-spring-web.cjs'
import { ChangeEvent, useEffect, useState } from 'react'

import Button from '~/components/Buttons/Button'
import useCurrentUser from '~/hooks/useCurrentUser'
import { ButtonPrimary } from '~/components/Buttons'
import { ContainerHomGradientBorder } from '~/components/Containers'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import TimesIcon from '~/components/Icons/svgs/TimesIcon'
import { useAppDispatch } from '~/redux/hooks'
import { useUpdateUserMutation } from '~/redux/apis/user-api'

import { setShowNicknameOverlay } from '../../redux/statistics.slice'

export default function NicknameOverlay(): React.ReactElement {
  const { t } = useTranslation(['settings', 'statistics', 'generics'])

  const [nickname, setNickname] = useState('')

  const user = useCurrentUser()
  const dispatch = useAppDispatch()
  const [updateUserData, { isLoading, isSuccess }] = useUpdateUserMutation()

  const spring = useSpring({
    from: { opacity: 0, y: -20 },
    to: { opacity: 1, y: 0 },
  })

  useEffect(() => {
    if (isSuccess) {
      dispatch(setShowNicknameOverlay(false))
    }
  }, [dispatch, isSuccess])

  const onClickSave = (): void => {
    if (!nickname || !user?.id) {
      return
    }

    updateUserData({ id: user.id, data: { nickname } })
  }

  const onClickRevert = (): void => {
    setNickname('')
  }

  return (
    <aside className="fixed inset-0 z-50 bg-black/80 backdrop-filter backdrop-blur-sm">
      <section className="h-full flex items-center justify-center">
        <Button
          aria-label={t('generics:ariaLabelButtons.closeWindow')}
          className="absolute top-20 right-4 text-white"
          onClick={() => {
            dispatch(setShowNicknameOverlay(false))
          }}
          size="small"
        >
          <SVGIcon icon={TimesIcon} pathClassName="text-white" size={14} />
        </Button>
        <a.div className="w-full sm:w-96 mx-2 sm:mx-auto text-black" style={spring}>
          <section className="relative pb-6 pt-5 rounded">
            <div className=" max-w-sm w-full mx-auto">
              <ContainerHomGradientBorder>
                <input
                  className="w-full rounded-full outline-0 p-1 text-md text-center"
                  onInput={(e: ChangeEvent<HTMLInputElement>) => setNickname(e.target.value)}
                  placeholder={t('statistics:create-nickname')}
                  value={nickname}
                />
              </ContainerHomGradientBorder>
              <div className="flex mt-3 space-x-4">
                <Button
                  className="bg-white text-purple ring-2 ring-purple py-1"
                  isFullWidth
                  noPadding
                  onClick={onClickRevert}
                  size="small"
                >
                  {t('settings:revertButton')}
                </Button>
                <ButtonPrimary
                  className="py-1"
                  isFullWidth
                  isLoading={isLoading}
                  noPadding
                  onClick={onClickSave}
                  size="small"
                >
                  {t('settings:saveButton')}
                </ButtonPrimary>
              </div>
            </div>
          </section>
        </a.div>
      </section>
    </aside>
  )
}
